import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'icon-book',
  templateUrl: './icon-book.component.html',
  styleUrls: ['./icon-book.component.scss'],
})
export class IconBookComponent  implements OnInit {
  @Input() size :number = 20;
  constructor() { }

  ngOnInit() {}

}
